import { fetchWrapper } from '@/_helpers';

export const contactApi = {
    // Contact Notes
    getContactNotes: (contactId) => fetchWrapper.get(`contacts/${contactId}/notes`),
};
